import { createContext, Dispatch, SetStateAction, useContext } from "react";

import { NewUser } from "@/api/endpoints/organization";
import { User } from "@/types/User";

export type InviteContextProps = {
  user: Nullable<User>;
  userDefaults?: Partial<NewUser>;
  organizationUuid: string;
  setUser: Dispatch<SetStateAction<Nullable<User>>>;
  reset: () => void;
};

const InviteContext = createContext<InviteContextProps>(
  {} as InviteContextProps
);

export const useInviteContext = () => useContext(InviteContext);
export default InviteContext;
